/*
 * @Author: gaozhaodong
 * @Date: 2023-04-30 23:43:42
 * @Description: file content
 * @FilePath: /parking_bmw_h5/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './route'
import components from "./components"
import '@/assets/font/font.css'
//选择组件
import AwesomePicker from 'vue-awesome-picker';
Vue.use(AwesomePicker);

// Boostrap-Vue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//http请求 npm install axios
import axios from 'axios'
Vue.prototype.$ajax = axios;
//开关按钮
import CheckboxRadio from 'vue-checkbox-radio';
Vue.use(CheckboxRadio);
//Alert弹框
import {
  Alert
} from 'bootstrap-vue/es/components';
Vue.use(Alert);
import 'mint-ui/lib/style.css'
import Mint from 'mint-ui';
Vue.use(Mint);

import  vant from 'vant';
Vue.use(vant);

import { DatetimePicker } from 'mint-ui';
Vue.component(DatetimePicker.name, DatetimePicker);
/** 语言包*/
import VueI18n from 'vue-i18n'
Vue.use(VueI18n); // 通过插件的形式挂载
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh_CN',    // 语言标识
  messages: {
    'zh_CN': require('./lang/zh.js'),   // 中文语言包
    'en_US': require('./lang/en.js')    // 英文语言包
  }
});
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
Vue.config.productionTip = false
Math.formatFloat = function (f, digit) {
	var m = Math.pow(10, digit);
	return Math.round(f * m, 10) / m;
}
//组件注册
Object.keys(components).forEach(k=>Vue.component(k,components[k]));
//数据共享 emit on
window.eventBus = new Vue();
Vue.prototype.wxJSAPIReady = false;
import { getWxJSAPISign } from "./api/wx.js";
import {
		getBrowserType
	} from '@/utils/common.js'
let browserType = getBrowserType()
if (browserType === 1) {
	getWxJSAPISign({url:location.href.split('#')[0]}).then(response=>{
		if(response.status==200){
				let data = response.data.result;
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId:data.appId, // 必填，公众号的唯一标识
					timestamp:data.timestamp , // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.sign,// 必填，签名
					jsApiList: ['getLocation','openLocation'] // 必填，需要使用的JS接口列表
			});
		}
	});
}

wx.ready(function(){
	Vue.prototype.wxJSAPIReady = true;
});
new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
